import React from "react";
import { CloseIcon } from "icons/close/CloseIcon";
import WirePaymentSuccess from "components/actionCenter/WirePaymentSuccess";
import { useTid } from "utils/testid";

interface SuccessWirePaymentProps {
  wireDetails: any;
  invoiceId: string;
  sendEmail: (values: any) => Promise<void>;
  leadId: string;
  onClose: () => void;
}

const SuccessWirePayment: React.FC<SuccessWirePaymentProps> = ({
  wireDetails,
  invoiceId,
  sendEmail,
  leadId,
  onClose,
}) => {
  const tid = useTid();

  return (
    <div
      className="w-full h-full "
      data-testid={tid("update-plan-success-wire")}
      aria-label="Wire payment plan update successful"
    >
      <div className="flex justify-end">
        <div
          onClick={() => onClose()}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onClose();
            }
          }}
          className="cursor-pointer p-2 rounded-full hover:!bg-bgSecondary"
          role="button"
          tabIndex={0}
          data-testid={tid("update-plan-success-wire-close-button")}
          aria-label="Close successful wire payment plan update"
        >
          <CloseIcon aria-hidden="true" />
        </div>
      </div>
      <div
        className="lg:px-0 px-5 grid place-items-center "
        data-testid={tid("update-plan-success-wire-content")}
      >
        <WirePaymentSuccess
          bankDetails={wireDetails}
          orderId={invoiceId}
          sendEmail={sendEmail}
          lead_id={leadId}
          className=""
        />
      </div>
    </div>
  );
};

export default SuccessWirePayment;
